import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  minify1kh64osmcox7j as minify,
  access$formatDecodingException$tJsonExceptionsKt2yfifxvnjk03f as access$formatDecodingException$tJsonExceptionsKt,
  InvalidKeyKindException3b5w96w0jjxof as InvalidKeyKindException,
  access$nonFiniteFpMessage$tJsonExceptionsKt13lbsnfrx5cw2 as access$nonFiniteFpMessage$tJsonExceptionsKt,
} from './JsonExceptions.mjs';
import { JsonDecodingExceptionoyag1psadwuw as JsonDecodingException } from '../JsonExceptions.mjs';
import { NamedValueDecoderzk26ztf92xbq as NamedValueDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Tagged.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import { classDiscriminator9fd3hvqsgfqq as classDiscriminator } from './Polymorphic.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull2liwjj96vm0w2 as JsonNull,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive,
  JsonNull_getInstance39w6eplghmtxw as JsonNull_getInstance,
  get_booleanOrNull376axlcpdhkmo as get_booleanOrNull,
  parseLongImpl2gkj8byk018b9 as parseLongImpl,
  get_float1xtaobzj8js8m as get_float,
  get_double1785hcxaminy4 as get_double,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
  JsonPrimitiveolttw629wj53 as JsonPrimitive_0,
} from '../JsonElement.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  LIST_getInstance2xmlsct1exo3w as LIST_getInstance,
  ENUM_getInstance1f3d4zr61j5rk as ENUM_getInstance,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  MAP_getInstance173r3f2itu405 as MAP_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { carrierDescriptor9eih94weel9f as carrierDescriptor } from './WriteMode.mjs';
import {
  getJsonNameIndexOrThrow1a6a29i1xie0m as getJsonNameIndexOrThrow,
  getJsonNameIndex1fee1p51fy8fj as getJsonNameIndex,
  namingStrategy2xiv9qzked2jy as namingStrategy,
  deserializationNamesMap29c3n2byxqy5b as deserializationNamesMap,
  ignoreUnknownKeys1ot1okvsp9ttf as ignoreUnknownKeys,
  get_JsonDeserializationNamesKey2d6gbfp1rff81 as get_JsonDeserializationNamesKey,
} from './JsonNamesMap.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { contains2c50nlxg7en7o as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  convertToByte2t4hntblnhq2k as convertToByte,
  convertToShortn6n5n7ruahkm as convertToShort,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { single29ec4rh52687r as single } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { Char19o2r8palgjof as Char } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { StringJsonLexer3eu6xom7mrcfu as StringJsonLexer } from './StringJsonLexer.mjs';
import { JsonDecoderForUnsignedTypesaowwj2t4rf8t as JsonDecoderForUnsignedTypes } from './StreamingJsonDecoder.mjs';
import { get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber } from './StreamingJsonEncoder.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from '../JsonDecoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { jsonCachedSerialNameslxufy2gu43jt as jsonCachedSerialNames } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/JsonInternalDependencies.mjs';
import { get_schemaCache3drvxe6e7799s as get_schemaCache } from '../JsonSchemaCache.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { toInt2q8uldh7sc951 as toInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
  return (new (JsonTreeDecoder())(_this__u8e3s4, element, discriminator, deserializer.h1m())).x1q(deserializer);
}
function unparsedPrimitive($this, literal, primitive, tag) {
  var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
  var tmp2 = "Failed to parse literal '" + literal.toString() + "' as " + type + ' value';
  // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
  var path = $this.m2u(tag);
  var tmp;
  if ($this.y2n().t2l_1.x2n_1) {
    var tmp$ret$3 = toString($this.n2u());
    tmp = toString(minify(tmp$ret$3));
  } else {
    tmp = null;
  }
  var inputValue = tmp;
  throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
}
var AbstractJsonTreeDecoderClass;
function AbstractJsonTreeDecoder() {
  if (AbstractJsonTreeDecoderClass === VOID) {
    class $ extends NamedValueDecoder() {
      constructor(json, value, polymorphicDiscriminator) {
        polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
        super();
        this.i2u_1 = json;
        this.j2u_1 = value;
        this.k2u_1 = polymorphicDiscriminator;
        this.l2u_1 = this.y2n().t2l_1;
      }
      y2n() {
        return this.i2u_1;
      }
      n3() {
        return this.j2u_1;
      }
      n1r() {
        return this.y2n().n1r();
      }
      n2u() {
        var tmp0_safe_receiver = this.m25();
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.o2u(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.n3() : tmp1_elvis_lhs;
      }
      m2u(currentTag) {
        return this.o25() + ('.' + currentTag);
      }
      z2n() {
        return this.n2u();
      }
      x1q(deserializer) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
          var tmp;
          if (!(deserializer instanceof AbstractPolymorphicSerializer())) {
            tmp = true;
          } else {
            tmp = this.y2n().t2l_1.o2n_1;
          }
          if (tmp) {
            tmp$ret$0 = deserializer.j1m(this);
            break $l$block;
          }
          var discriminator = classDiscriminator(deserializer.h1m(), this.y2n());
          var tmp2 = this.z2n();
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = deserializer.h1m().k1n();
          if (!(tmp2 instanceof JsonObject())) {
            var tmp2_0 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(tmp2).j1() + ' as the serialized body of ' + serialName;
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.o25();
            var tmp_0;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$6 = toString(tmp2);
              tmp_0 = toString(minify(tmp$ret$6));
            } else {
              tmp_0 = null;
            }
            var inputValue = tmp_0;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
          }
          var jsonTree = tmp2;
          var tmp0_safe_receiver = jsonTree.d2o(discriminator);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
          var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
          var tmp_1;
          try {
            tmp_1 = findPolymorphicSerializer(deserializer, this, type);
          } catch ($p) {
            var tmp_2;
            if ($p instanceof SerializationException()) {
              var it = $p;
              // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
              var shortMessage = ensureNotNull(it.message);
              var tmp_3;
              if (this.y2n().t2l_1.x2n_1) {
                var tmp$ret$10 = jsonTree.toString();
                tmp_3 = toString(minify(tmp$ret$10));
              } else {
                tmp_3 = null;
              }
              var inputValue_0 = tmp_3;
              throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue_0), shortMessage, -1, null, inputValue_0, null);
            } else {
              throw $p;
            }
          }
          var tmp_4 = tmp_1;
          var actualSerializer = isInterface(tmp_4, DeserializationStrategy()) ? tmp_4 : THROW_CCE();
          tmp$ret$0 = readPolymorphicJson(this.y2n(), discriminator, jsonTree, actualSerializer);
        }
        return tmp$ret$0;
      }
      n25(parentName, childName) {
        return childName;
      }
      y1q(descriptor) {
        var currentObject = this.n2u();
        var tmp0_subject = descriptor.d1p();
        var tmp;
        var tmp_0;
        if (equals(tmp0_subject, LIST_getInstance())) {
          tmp_0 = true;
        } else {
          tmp_0 = tmp0_subject instanceof PolymorphicKind();
        }
        if (tmp_0) {
          var tmp_1 = this.y2n();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = descriptor.k1n();
          if (!(currentObject instanceof JsonArray())) {
            var tmp2 = 'Expected ' + getKClass(JsonArray()).j1() + ', but had ' + getKClassFromExpression(currentObject).j1() + ' as the serialized body of ' + serialName;
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.o25();
            var tmp_2;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$6 = toString(currentObject);
              tmp_2 = toString(minify(tmp$ret$6));
            } else {
              tmp_2 = null;
            }
            var inputValue = tmp_2;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          tmp = new (JsonTreeListDecoder())(tmp_1, currentObject);
        } else {
          if (equals(tmp0_subject, MAP_getInstance())) {
            // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
            var this_0 = this.y2n();
            var keyDescriptor = carrierDescriptor(descriptor.k1p(0), this_0.n1r());
            var keyKind = keyDescriptor.d1p();
            var tmp_3;
            var tmp_4;
            if (keyKind instanceof PrimitiveKind()) {
              tmp_4 = true;
            } else {
              tmp_4 = equals(keyKind, ENUM_getInstance());
            }
            if (tmp_4) {
              var tmp_5 = this.y2n();
              // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
              // Inline function 'kotlinx.serialization.json.internal.cast' call
              var serialName_0 = descriptor.k1n();
              if (!(currentObject instanceof JsonObject())) {
                var tmp2_0 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(currentObject).j1() + ' as the serialized body of ' + serialName_0;
                // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                var path_0 = this.o25();
                var tmp_6;
                if (this.y2n().t2l_1.x2n_1) {
                  var tmp$ret$15 = toString(currentObject);
                  tmp_6 = toString(minify(tmp$ret$15));
                } else {
                  tmp_6 = null;
                }
                var inputValue_0 = tmp_6;
                throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path_0, null, inputValue_0), tmp2_0, -1, path_0, inputValue_0, null);
              }
              tmp_3 = new (JsonTreeMapDecoder())(tmp_5, currentObject);
            } else {
              if (this_0.t2l_1.j2n_1) {
                var tmp_7 = this.y2n();
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
                // Inline function 'kotlinx.serialization.json.internal.cast' call
                var serialName_1 = descriptor.k1n();
                if (!(currentObject instanceof JsonArray())) {
                  var tmp2_1 = 'Expected ' + getKClass(JsonArray()).j1() + ', but had ' + getKClassFromExpression(currentObject).j1() + ' as the serialized body of ' + serialName_1;
                  // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                  var path_1 = this.o25();
                  var tmp_8;
                  if (this.y2n().t2l_1.x2n_1) {
                    var tmp$ret$23 = toString(currentObject);
                    tmp_8 = toString(minify(tmp$ret$23));
                  } else {
                    tmp_8 = null;
                  }
                  var inputValue_1 = tmp_8;
                  throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, path_1, null, inputValue_1), tmp2_1, -1, path_1, inputValue_1, null);
                }
                tmp_3 = new (JsonTreeListDecoder())(tmp_7, currentObject);
              } else {
                throw InvalidKeyKindException(keyDescriptor);
              }
            }
            tmp = tmp_3;
          } else {
            var tmp_9 = this.y2n();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName_2 = descriptor.k1n();
            if (!(currentObject instanceof JsonObject())) {
              var tmp2_2 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(currentObject).j1() + ' as the serialized body of ' + serialName_2;
              // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
              var path_2 = this.o25();
              var tmp_10;
              if (this.y2n().t2l_1.x2n_1) {
                var tmp$ret$30 = toString(currentObject);
                tmp_10 = toString(minify(tmp$ret$30));
              } else {
                tmp_10 = null;
              }
              var inputValue_2 = tmp_10;
              throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_2, path_2, null, inputValue_2), tmp2_2, -1, path_2, inputValue_2, null);
            }
            tmp = new (JsonTreeDecoder())(tmp_9, currentObject, this.k2u_1);
          }
        }
        return tmp;
      }
      z1q(descriptor) {
      }
      j1q() {
        var tmp = this.n2u();
        return !(tmp instanceof JsonNull());
      }
      p2u(tag, enumDescriptor) {
        var tmp = this.y2n();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
        var tmp2 = this.o2u(tag);
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName = enumDescriptor.k1n();
        if (!(tmp2 instanceof JsonPrimitive())) {
          var tmp2_0 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(tmp2).j1() + ' as the serialized body of ' + serialName;
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var path = this.m2u(tag);
          var tmp_0;
          if (this.y2n().t2l_1.x2n_1) {
            var tmp$ret$7 = toString(tmp2);
            tmp_0 = toString(minify(tmp$ret$7));
          } else {
            tmp_0 = null;
          }
          var inputValue = tmp_0;
          throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
        }
        return getJsonNameIndexOrThrow(enumDescriptor, tmp, tmp2.a2o());
      }
      a26(tag, enumDescriptor) {
        return this.p2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
      }
      q2u(tag) {
        return !(this.o2u(tag) === JsonNull_getInstance());
      }
      q25(tag) {
        return this.q2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      r2u(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.o2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'boolean';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.m2u(tag);
            var tmp;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = get_booleanOrNull(literal);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'boolean', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'boolean', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      r25(tag) {
        return this.r2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      s2u(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.o2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'byte';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.m2u(tag);
            var tmp;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var result = parseLongImpl(literal);
            var tmp_0;
            // Inline function 'kotlin.ranges.contains' call
            var this_0 = numberRangeToNumber(-128, 127);
            if (contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), result)) {
              tmp_0 = convertToByte(result);
            } else {
              tmp_0 = null;
            }
            var tmp0_elvis_lhs = tmp_0;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'byte', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'byte', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      s25(tag) {
        return this.s2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      t2u(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.o2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'short';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.m2u(tag);
            var tmp;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var result = parseLongImpl(literal);
            var tmp_0;
            // Inline function 'kotlin.ranges.contains' call
            var this_0 = numberRangeToNumber(-32768, 32767);
            if (contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), result)) {
              tmp_0 = convertToShort(result);
            } else {
              tmp_0 = null;
            }
            var tmp0_elvis_lhs = tmp_0;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'short', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'short', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      t25(tag) {
        return this.t2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      u2u(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.o2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'int';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.m2u(tag);
            var tmp;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var result = parseLongImpl(literal);
            var tmp_0;
            // Inline function 'kotlin.ranges.contains' call
            var this_0 = numberRangeToNumber(-2147483648, 2147483647);
            if (contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), result)) {
              tmp_0 = convertToInt(result);
            } else {
              tmp_0 = null;
            }
            var tmp0_elvis_lhs = tmp_0;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'int', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'int', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      u25(tag) {
        return this.u2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      v2u(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.o2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'long';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.m2u(tag);
            var tmp;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = parseLongImpl(literal);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'long', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'long', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      v25(tag) {
        return this.v2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      w2u(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.o2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'float';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.m2u(tag);
            var tmp;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = get_float(literal);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'float', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'float', tag);
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.y2n().t2l_1.q2n_1;
        if (specialFp || isFinite(result))
          return result;
        // Inline function 'kotlinx.serialization.json.internal.InvalidFloatingPointDecoded' call
        var tmp2_0 = access$nonFiniteFpMessage$tJsonExceptionsKt(result, tag);
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var hint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
        var tmp_1;
        if (this.y2n().t2l_1.x2n_1) {
          var tmp$ret$13 = toString(this.n2u());
          tmp_1 = toString(minify(tmp$ret$13));
        } else {
          tmp_1 = null;
        }
        var inputValue_0 = tmp_1;
        throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, null, hint, inputValue_0), tmp2_0, -1, null, inputValue_0, hint);
      }
      w25(tag) {
        return this.w2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      x2u(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.o2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'double';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.m2u(tag);
            var tmp;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = get_double(literal);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'double', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'double', tag);
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.y2n().t2l_1.q2n_1;
        if (specialFp || isFinite_0(result))
          return result;
        // Inline function 'kotlinx.serialization.json.internal.InvalidFloatingPointDecoded' call
        var tmp2_0 = access$nonFiniteFpMessage$tJsonExceptionsKt(result, tag);
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var hint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
        var tmp_1;
        if (this.y2n().t2l_1.x2n_1) {
          var tmp$ret$13 = toString(this.n2u());
          tmp_1 = toString(minify(tmp$ret$13));
        } else {
          tmp_1 = null;
        }
        var inputValue_0 = tmp_1;
        throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, null, hint, inputValue_0), tmp2_0, -1, null, inputValue_0, hint);
      }
      x25(tag) {
        return this.x2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      y2u(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.o2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'char';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.m2u(tag);
            var tmp;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = new (Char())(single(literal.a2o()));
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'char', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0.e4_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'char', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      y25(tag) {
        return this.y2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      z2u(tag) {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var value = this.o2u(tag);
        if (!(value instanceof JsonPrimitive())) {
          var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'string';
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var path = this.m2u(tag);
          var tmp;
          if (this.y2n().t2l_1.x2n_1) {
            var tmp$ret$6 = toString(value);
            tmp = toString(minify(tmp$ret$6));
          } else {
            tmp = null;
          }
          var inputValue = tmp;
          throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
        }
        var value_0 = value;
        if (!(value_0 instanceof JsonLiteral())) {
          var tmp2_0 = "Expected string value for a non-null key '" + tag + "', got null literal instead";
          var tmp4 = this.m2u(tag);
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var hint = "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.";
          var tmp_0;
          if (this.y2n().t2l_1.x2n_1) {
            var tmp$ret$10 = toString(this.n2u());
            tmp_0 = toString(minify(tmp$ret$10));
          } else {
            tmp_0 = null;
          }
          var inputValue_0 = tmp_0;
          throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, tmp4, hint, inputValue_0), tmp2_0, -1, tmp4, inputValue_0, hint);
        }
        if (!value_0.j2o_1 && !this.y2n().t2l_1.i2n_1) {
          var tmp2_1 = "String literal for value of key '" + tag + "' should be quoted";
          var tmp4_0 = this.m2u(tag);
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var hint_0 = "Use 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.";
          var tmp_1;
          if (this.y2n().t2l_1.x2n_1) {
            var tmp$ret$14 = toString(this.n2u());
            tmp_1 = toString(minify(tmp$ret$14));
          } else {
            tmp_1 = null;
          }
          var inputValue_1 = tmp_1;
          throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, tmp4_0, hint_0, inputValue_1), tmp2_1, -1, tmp4_0, inputValue_1, hint_0);
        }
        return value_0.l2o_1;
      }
      z25(tag) {
        return this.z2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      a2v(tag, inlineDescriptor) {
        var tmp;
        if (get_isUnsignedNumber(inlineDescriptor)) {
          var tmp_0 = this.y2n();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          var tmp2 = this.o2u(tag);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = inlineDescriptor.k1n();
          if (!(tmp2 instanceof JsonPrimitive())) {
            var tmp2_0 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(tmp2).j1() + ' as the serialized body of ' + serialName;
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.m2u(tag);
            var tmp_1;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$7 = toString(tmp2);
              tmp_1 = toString(minify(tmp$ret$7));
            } else {
              tmp_1 = null;
            }
            var inputValue = tmp_1;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
          }
          var lexer = StringJsonLexer(tmp_0, tmp2.a2o());
          tmp = new (JsonDecoderForUnsignedTypes())(lexer, this.y2n());
        } else {
          tmp = super.b26(tag, inlineDescriptor);
        }
        return tmp;
      }
      b26(tag, inlineDescriptor) {
        return this.a2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
      }
      v1q(descriptor) {
        return !(this.m25() == null) ? super.v1q(descriptor) : (new (JsonPrimitiveDecoder())(this.y2n(), this.n3(), this.k2u_1)).v1q(descriptor);
      }
    }
    initMetadataForClass($, 'AbstractJsonTreeDecoder', VOID, VOID, [JsonDecoder()]);
    AbstractJsonTreeDecoderClass = $;
  }
  return AbstractJsonTreeDecoderClass;
}
function setForceNull($this, descriptor, index) {
  $this.k2v_1 = (!$this.y2n().t2l_1.l2n_1 && !descriptor.l1p(index) && descriptor.k1p(index).w1o());
  return $this.k2v_1;
}
var JsonTreeDecoderClass;
function JsonTreeDecoder() {
  if (JsonTreeDecoderClass === VOID) {
    class $ extends AbstractJsonTreeDecoder() {
      constructor(json, value, polymorphicDiscriminator, polyDescriptor) {
        polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
        polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
        super(json, value, polymorphicDiscriminator);
        this.h2v_1 = value;
        this.i2v_1 = polyDescriptor;
        this.j2v_1 = 0;
        this.k2v_1 = false;
      }
      n3() {
        return this.h2v_1;
      }
      p1r(descriptor) {
        $l$loop: while (this.j2v_1 < descriptor.f1p()) {
          var _unary__edvuaz = this.j2v_1;
          this.j2v_1 = _unary__edvuaz + 1 | 0;
          var name = this.h25(descriptor, _unary__edvuaz);
          var index = this.j2v_1 - 1 | 0;
          this.k2v_1 = false;
          var tmp;
          // Inline function 'kotlin.collections.contains' call
          // Inline function 'kotlin.collections.containsKey' call
          var this_0 = this.n3();
          if ((isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).v4(name)) {
            tmp = true;
          } else {
            tmp = setForceNull(this, descriptor, index);
          }
          if (tmp) {
            if (!this.l2u_1.n2n_1)
              return index;
            var tmp0 = this.y2n();
            var tmp$ret$2;
            $l$block_2: {
              // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
              var isOptional = descriptor.l1p(index);
              var elementDescriptor = descriptor.k1p(index);
              var tmp_0;
              if (isOptional && !elementDescriptor.w1o()) {
                var tmp_1 = this.l2v(name);
                tmp_0 = tmp_1 instanceof JsonNull();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$2 = true;
                break $l$block_2;
              }
              if (equals(elementDescriptor.d1p(), ENUM_getInstance())) {
                var tmp_2;
                if (elementDescriptor.w1o()) {
                  var tmp_3 = this.l2v(name);
                  tmp_2 = tmp_3 instanceof JsonNull();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$2 = false;
                  break $l$block_2;
                }
                var tmp_4 = this.l2v(name);
                var tmp0_safe_receiver = tmp_4 instanceof JsonPrimitive() ? tmp_4 : null;
                var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
                var tmp_5;
                if (tmp0_elvis_lhs == null) {
                  tmp$ret$2 = false;
                  break $l$block_2;
                } else {
                  tmp_5 = tmp0_elvis_lhs;
                }
                var enumValue = tmp_5;
                var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
                var coerceToNull = !tmp0.t2l_1.l2n_1 && elementDescriptor.w1o();
                if (enumIndex === -3 && (isOptional || coerceToNull)) {
                  if (setForceNull(this, descriptor, index))
                    return index;
                  tmp$ret$2 = true;
                  break $l$block_2;
                }
              }
              tmp$ret$2 = false;
            }
            if (tmp$ret$2)
              continue $l$loop;
            return index;
          }
        }
        return -1;
      }
      j1q() {
        return !this.k2v_1 && super.j1q();
      }
      i25(descriptor, index) {
        var strategy = namingStrategy(descriptor, this.y2n());
        var baseName = descriptor.h1p(index);
        if (strategy == null) {
          if (!this.l2u_1.r2n_1)
            return baseName;
          if (this.n3().y4().t2(baseName))
            return baseName;
        }
        var deserializationNamesMap_0 = deserializationNamesMap(this.y2n(), descriptor);
        // Inline function 'kotlin.collections.find' call
        var tmp0 = this.n3().y4();
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (deserializationNamesMap_0.x4(element) === index) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp0_safe_receiver;
        }
        var fallbackName = strategy == null ? null : strategy.a2s(descriptor, index, baseName);
        return fallbackName == null ? baseName : fallbackName;
      }
      o2u(tag) {
        return getValue(this.n3(), tag);
      }
      l2v(tag) {
        return this.n3().d2o(tag);
      }
      y1q(descriptor) {
        if (descriptor === this.i2v_1) {
          var tmp = this.y2n();
          var tmp2 = this.n2u();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = this.i2v_1.k1n();
          if (!(tmp2 instanceof JsonObject())) {
            var tmp2_0 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(tmp2).j1() + ' as the serialized body of ' + serialName;
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.o25();
            var tmp_0;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$6 = toString(tmp2);
              tmp_0 = toString(minify(tmp$ret$6));
            } else {
              tmp_0 = null;
            }
            var inputValue = tmp_0;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
          }
          return new (JsonTreeDecoder())(tmp, tmp2, this.k2u_1, this.i2v_1);
        }
        return super.y1q(descriptor);
      }
      z1q(descriptor) {
        var tmp;
        if (ignoreUnknownKeys(descriptor, this.y2n())) {
          tmp = true;
        } else {
          var tmp_0 = descriptor.d1p();
          tmp = tmp_0 instanceof PolymorphicKind();
        }
        if (tmp)
          return Unit_instance;
        var strategy = namingStrategy(descriptor, this.y2n());
        var tmp_1;
        if (strategy == null && !this.l2u_1.r2n_1) {
          tmp_1 = jsonCachedSerialNames(descriptor);
        } else if (!(strategy == null)) {
          tmp_1 = deserializationNamesMap(this.y2n(), descriptor).y4();
        } else {
          var tmp_2 = jsonCachedSerialNames(descriptor);
          var tmp0_safe_receiver = get_schemaCache(this.y2n()).l2t(descriptor, get_JsonDeserializationNamesKey());
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y4();
          var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
          tmp_1 = plus(tmp_2, tmp$ret$0);
        }
        var names = tmp_1;
        var _iterator__ex2g4s = this.n3().y4().p1();
        while (_iterator__ex2g4s.q1()) {
          var key = _iterator__ex2g4s.r1();
          if (!names.t2(key) && !(key === this.k2u_1)) {
            var tmp2 = "Encountered an unknown key '" + key + "'";
            var tmp4 = this.o25();
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var hint = "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.";
            var tmp_3;
            if (this.y2n().t2l_1.x2n_1) {
              var tmp$ret$4 = this.n3().toString();
              tmp_3 = toString(minify(tmp$ret$4));
            } else {
              tmp_3 = null;
            }
            var inputValue = tmp_3;
            throw JsonDecodingException().l2p(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, tmp4, hint, inputValue), tmp2, -1, tmp4, inputValue, hint);
          }
        }
      }
    }
    initMetadataForClass($, 'JsonTreeDecoder');
    JsonTreeDecoderClass = $;
  }
  return JsonTreeDecoderClass;
}
var JsonTreeListDecoderClass;
function JsonTreeListDecoder() {
  if (JsonTreeListDecoderClass === VOID) {
    class $ extends AbstractJsonTreeDecoder() {
      constructor(json, value) {
        super(json, value);
        this.s2v_1 = value;
        this.t2v_1 = this.s2v_1.q2();
        this.u2v_1 = -1;
      }
      n3() {
        return this.s2v_1;
      }
      i25(descriptor, index) {
        return index.toString();
      }
      o2u(tag) {
        return this.s2v_1.r2(toInt(tag));
      }
      p1r(descriptor) {
        while (this.u2v_1 < (this.t2v_1 - 1 | 0)) {
          this.u2v_1 = this.u2v_1 + 1 | 0;
          return this.u2v_1;
        }
        return -1;
      }
    }
    initMetadataForClass($, 'JsonTreeListDecoder');
    JsonTreeListDecoderClass = $;
  }
  return JsonTreeListDecoderClass;
}
var JsonPrimitiveDecoderClass;
function JsonPrimitiveDecoder() {
  if (JsonPrimitiveDecoderClass === VOID) {
    class $ extends AbstractJsonTreeDecoder() {
      constructor(json, value, polymorphicDiscriminator) {
        polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
        super(json, value, polymorphicDiscriminator);
        this.b2w_1 = value;
        this.c26('primitive');
      }
      n3() {
        return this.b2w_1;
      }
      p1r(descriptor) {
        return 0;
      }
      o2u(tag) {
        // Inline function 'kotlin.require' call
        if (!(tag === 'primitive')) {
          var message = "This input can only handle primitives with 'primitive' tag";
          throw IllegalArgumentException().o2(toString(message));
        }
        return this.b2w_1;
      }
    }
    initMetadataForClass($, 'JsonPrimitiveDecoder');
    JsonPrimitiveDecoderClass = $;
  }
  return JsonPrimitiveDecoderClass;
}
var JsonTreeMapDecoderClass;
function JsonTreeMapDecoder() {
  if (JsonTreeMapDecoderClass === VOID) {
    class $ extends JsonTreeDecoder() {
      constructor(json, value) {
        super(json, value);
        this.m2w_1 = value;
        this.n2w_1 = toList(this.m2w_1.y4());
        this.o2w_1 = imul(this.n2w_1.q2(), 2);
        this.p2w_1 = -1;
      }
      n3() {
        return this.m2w_1;
      }
      i25(descriptor, index) {
        var i = index / 2 | 0;
        return this.n2w_1.r2(i);
      }
      p1r(descriptor) {
        while (this.p2w_1 < (this.o2w_1 - 1 | 0)) {
          this.p2w_1 = this.p2w_1 + 1 | 0;
          return this.p2w_1;
        }
        return -1;
      }
      o2u(tag) {
        return (this.p2w_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.m2w_1, tag);
      }
      z1q(descriptor) {
      }
    }
    initMetadataForClass($, 'JsonTreeMapDecoder');
    JsonTreeMapDecoderClass = $;
  }
  return JsonTreeMapDecoderClass;
}
//region block: exports
export {
  readPolymorphicJson as readPolymorphicJson7wfdzotvo8aj,
};
//endregion

//# sourceMappingURL=TreeJsonDecoder.mjs.map
